// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3u4pk","colBig":"styles_colBig__XxyBv","colSmall":"styles_colSmall__3hABj"};